/**
 * "Rematch" and "New game", for the action bar's game-over face (R5).
 *
 * Both conditions are READ OFF the result card's own selectors rather than
 * re-stated, so the bar and the card cannot offer different things:
 * `selectResultView.canRematch` is PlayChess's button condition line for line
 * (L5203-5205), and the CASUAL rule is `ResultOverlay`'s.
 */
import type {LiveGameState} from '@/Store/liveGameStore';
import {selectResultView} from '@/Store/liveGame/selectors';

/** the play-again row belongs to a CASUAL result; a tournament has no rematch. */
export const casualGame = (s: LiveGameState): boolean =>
  s.game.gamePlayMode !== 'tournament' && s.game.gamePlayMode !== 'arena';

export const selectCanRematch = (s: LiveGameState): boolean =>
  !!selectResultView(s)?.canRematch && casualGame(s);

export const selectCanPlayAgain = (s: LiveGameState): boolean =>
  !!s.game.result && casualGame(s) && s.game.tcMs > 0;
